// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ...

// —————————————————————————————————————————— HDL. DEF. ——————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function stChH_activeSection(CHANGES) {
  //////////////////////////////////////////// Setup /////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  const { activeSection } = CHANGES;
  if (this.options.log) console.warn("activeSection state change", activeSection);

  //////////////////////////////////// State change execution ////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  // Active menu link updt. //
  ////////////////////////////////////

  const { menuLinks } = this.ref;
  if (menuLinks && menuLinks.length) {
    menuLinks.forEach((l) => {
      const target_link = l.dataset.target?.replace(/^#/, "") || "";
      const isActive = target_link === activeSection || (activeSection === "hero" && target_link === "intro");
      l.dataset.active = isActive ? "true" : "false";
    });
  }

  //// Muting of back-to-top btn. ////
  ////////////////////////////////////

  // Mute back-to-top btn. when in 'gateway' section

  const shouldMute = activeSection === "gateway";
  if (this.state.navState.backToTopMuted !== shouldMute) {
    this.setState({ navState: { ...this.state.navState, backToTopMuted: shouldMute } });
  }
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
